import videojs from "!video.js";

const Component = videojs.getComponent('Component')

export class IFrameComponent extends Component{

    // The constructor of a component receives two arguments: the
    // player it will be associated with and an object of options.
    constructor(player, options = {}) {

        // It is important to invoke the superclass before anything else,
        // to get all the features of components out of the box!
        super(player, options);
    }

    createEl() {
        return videojs.dom.createEl('div', {
            // Prefixing classes of elements within a player with "vjs-"
            // is a convention used in Video.js.
            className: 'vjs-iframe-component',
            innerHTML: this.generateIFrame()
        });
    }

    generateIFrame() {
        return `<div style="padding:56.25% 0 0 0;">
            <iframe id='corsi-video-vimeo-iframe' 
                src='${this.options_.source}?controls=0&muted=1' 
                frameborder='0' 
                allow='autoplay;' 
                style='position:absolute;top:0;left:0;width:100%;height:100%;' 
                title='Corso di Training Autogeno (insegnato da una psicologa)'>
            </iframe>
        </div>`;
    }
}